export const isWindowsUser = () => window.navigator.userAgent.includes('Windows');
export const isMobileDevice = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
